<section class="job-openning-wrapper">
  <div class="box-wrapper">
    <h1 class="title">{{ 'JOB_OPENING.TITLE' | translate }}</h1>
    <ng-container *ngFor="let item of jobsList">
      <a
        class="box-container-link"
        [routerLink]="['position/' + item.data.jobNameUrl.iv]"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div class="box">
          <div class="box__left">
            <div class="box__title">{{ item.data.jobName.iv }}</div>
            <div class="box__description">
              <span class="span_highlight">{{ item.data.jobLocation ? item.data.jobLocation.iv : 'Bangkok' }}</span>

              <span class="span_highlight">{{ item.data.JobType.iv }}</span>
              <span class="span_highlight">{{ item.data.JobTeam.iv }}</span>
            </div>
          </div>
          <div class="box__right">
            <a
              class="box__link flowbtn app-border-btn"
              [routerLink]="['position/' + item.data.jobNameUrl.iv]"
              target="_blank"
              rel="noopener noreferrer"
              >Apply</a
            >
          </div>
        </div>
      </a>
    </ng-container>
  </div>
</section>
